import { Injectable } from "@angular/core";
import { productFruits } from "product-fruits";
import { CacheService } from "../../cache.service";
import { Token, ICompanySubscription } from "../../app.model";
import { NS_Enums } from "../../shared/namespaces";
import { isLocal } from "../../shared/helpers/local.helper";
import { environment } from "../../../environments/environment";
import { AppSwitcherService } from "../../shared/services/app-switcher/app-switcher.service";
import { UserDetails } from "../../app.model";
import { SubscriptionDataService } from "../../account/services/subscription-data.service";
import { catchError } from "rxjs/operators";
import { take } from "rxjs/operators";
import { of } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class ProductFruitService {
  tours: any;
  pf: any;
  hasProductFruit: boolean = false;

  actions: any[] = [];
  constructor(private subscriptionDataService: SubscriptionDataService) {}

  initProductFruit(userObj: UserDetails) {
    const {
      firstName,
      lastName,
      email,
      company: { companyId },
    } = userObj;
    if (this.hasProductFruit) return;

    // This now benefits from shared request pattern - if called in parallel with other services,
    // only one API call will be made and all subscribers will receive the same data
    this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(companyId).pipe( take(1), catchError((error: any) => { return of(null) }) ).subscribe((entries:ICompanySubscription[])=>{
      if(entries){
        this.hasProductFruit = true;
        productFruits.init(
          isLocal
            ? environment.PRODUCTFRUIT_LOCAL_KEY
            : environment.PRODUCTFRUIT_KEY,
          "en",
          {
            username: `${firstName} ${lastName}` || "",
            email: email || "",
            signUpAt: entries[0]?.created ? new Date(entries[0].created).toISOString() : '',
          },
          { disableLocationChangeDetection: false }
        );
        productFruits.safeExec(($pf) => {
          this.pf = $pf;
          if (this.actions.length) {
            this.tours = productFruits?.api?.tours;
          }
        });
      }
    })
  }

  startTour() {
    if (this.pf) {
      this.tours = productFruits?.api?.tours;
      console.log(this.pf, "tours");
    } else {
      this.actions.push("tour");
    }
  }

  getStartDate(datonEntry: ICompanySubscription){
    switch (datonEntry.status) {
      case 'TRIAL':
        return datonEntry.cycleStartDate ? new Date(datonEntry.cycleStartDate).toISOString() : "";
    
      default:
        return datonEntry.subscriptionPlan.product.created ? new Date(datonEntry.subscriptionPlan.product.created).toISOString() : "";
    }
  }
}
